var BaseShapeUIModel = require('../../../shapeUI');


/**
 * Extend base defaults with isDeniedInFull flag ,which defaults to true.
 * These shapes can either be 'Denied in Full' (true) or 'Non-Responsive' (false).
 * Utilize to track and trigger changes in the associated view, as well as validate values on save,
 * which come directly from the parent shape model.
 */


module.exports = BaseShapeUIModel.extend({

    defaults: _.extend( {}, BaseShapeUIModel.prototype.defaults, {

        isDeniedInFull: true

    })

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/models/coordinate/redaction/fullPageRedaction/shapeUIModel.js
 ** module id = 319
 ** module chunks = 0
 **/